import { numeroMilhar } from "../../../../../../../utils";

const unidade_medida_local = [
    { cod: 1, nome_completo: 'L/ha', nome: 'L', nome_filtro: 'l', tipo_fisico: 'Líquido' },
    { cod: 2, nome_completo: 'mL/ha', nome: 'mL', nome_filtro: 'ml', tipo_fisico: 'Líquido' },
    { cod: 3, nome_completo: 'Kg/ha', nome: 'Kg', nome_filtro: 'kg', tipo_fisico: 'Sólido' },
    { cod: 4, nome_completo: 'g/ha', nome: 'g', nome_filtro: 'g', tipo_fisico: 'Sólido' },
    { cod: 5, nome_completo: 'sc/ha', nome: 'sc', nome_filtro: 'sc', tipo_fisico: 'Sólido' },
    { cod: 6, nome_completo: 'Kg/ha', nome: 'Kg', nome_filtro: 'kg', tipo_fisico: 'Sólido' },
    { cod: 7, nome_completo: 't/ha', nome: 't', nome_filtro: 't', tipo_fisico: 'Sólido' },
    { cod: 8, nome_completo: '@/ha', nome: '@', nome_filtro: '@', tipo_fisico: 'Sólido' },
    { cod: 9, nome_completo: 'sementes/ha', nome: 'sementes', nome_filtro: 'sementes', tipo_fisico: 'Sementes' },
    { cod: 10, nome_completo: '%', nome: '%', nome_filtro: '%', tipo_fisico: 'Líquido' },
    { cod: 11, nome_completo: 'g/L', nome: 'g/L', nome_filtro: 'g/l', tipo_fisico: 'Líquido' },
    { cod: 12, nome_completo: 'Dose/ha', nome: 'Dose', nome_filtro: 'dose', tipo_fisico: 'Líquido' },
    { cod: 16, nome_completo: 'g/kg de semente', nome: 'g/kg de semente', nome_filtro: 'g/kg de semente', tipo_fisico: 'Sólido' },
    { cod: 17, nome_completo: 'mL/kg de semente', nome: 'mL/kg de semente', nome_filtro: 'mL/kg de semente', tipo_fisico: 'Líquido' },
    { cod: 18, nome_completo: 'L/tanque de pulverização', nome: 'L/tanque de pulverização', nome_filtro: 'L/tanque de pulverização', tipo_fisico: 'Líquido' },
];

/**Normaliza quantidade em um valor em comum.
 * 
 * g -> kg
 * 
 * t -> kg
 * 
 * ml -> L
 */
export function normalizarQuantidadeInsumos(quantidade: number, cod_medida: number) {

    switch (cod_medida) {
        case 1: //L
            return { quantidade, medida_normalizada: 'L', cod_medida_normalizada: 1 };
        case 2: //mL
            return { quantidade: quantidade / 1000, medida_normalizada: 'L', cod_medida_normalizada: 1 };
        case 3: //Kg
            return { quantidade, medida_normalizada: 'Kg', cod_medida_normalizada: 3 };
        case 4: //g
            return { quantidade: quantidade / 1000, medida_normalizada: 'Kg', cod_medida_normalizada: 3 };
        case 6: //Kg
            return { quantidade, medida_normalizada: 'Kg', cod_medida_normalizada: 3 };
        case 7: //t
            return { quantidade: quantidade * 1000, medida_normalizada: 'Kg', cod_medida_normalizada: 3 };
        case 9: //SEMENTES
            return { quantidade, medida_normalizada: 'sementes', cod_medida_normalizada: 9 };
        case 12: //doses
            return { quantidade, medida_normalizada: 'doses', cod_medida_normalizada: 12 };
        default:
            return { quantidade, medida_normalizada: '', cod_medida_normalizada: 0 };
    }

}


export function viewQuantidadeInsumos(quantidade: number, cod_medida_normalizada: number) {
    if (cod_medida_normalizada === 1) {
        if (quantidade < 1) {
            return `${numeroMilhar(quantidade * 1000)} mL`
        }
        return `${numeroMilhar(quantidade)} L`
    }

    if (cod_medida_normalizada === 3) {
        if (quantidade < 1) {
            return `${numeroMilhar(quantidade * 1000)} g`
        }
        if (quantidade > 1000) {
            return `${numeroMilhar(quantidade / 1000)} t`
        }
        return `${numeroMilhar(quantidade)} Kg`
    }

    if (cod_medida_normalizada === 9) {
        if (quantidade > 1000000) {
            return `${numeroMilhar(quantidade / 1000000)} milhões de sementes`
        }
        return `${numeroMilhar(quantidade)} de sementes`
    }

    return `${numeroMilhar(quantidade)} ${unidade_medida_local.find(i => i.cod === cod_medida_normalizada)?.nome}`
}